module.exports = __webpack_public_path__ + "static/media/calendar.1a0f897d.svg";